export default "__VITE_ASSET__D9WITuZd__"